import React from "react";
import moment from "moment";
import { Panel, FormGroup, ControlLabel } from 'react-bootstrap';
import { useTranslation } from "react-i18next";
import { Add, Remove } from "../../../components/Icons/Icons";
import { Tooltip } from "../../../components/Utils/Tooltips";
import { formatSeq } from "../Hooks/protocolReturnRows";

export default function ProtocolReturnEntryPanel({ entry, index, disabled, onRemove, onReDispense }) {
    const { t } = useTranslation();

    return (
        <Panel eventKey={`return-entry-${index}`}>
            <Panel.Heading>
                <Panel.Title>
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                        <Panel.Title toggle>
                            <div style={{ display: "flex", alignItems: "center", gap: "1rem" }}>
                                {`${entry.presentation} - ${entry.returned}/${entry.perUnitTotal}`}
                                <small>{t('inventory.commons.comprobanteOf', { date: formatSeq(entry.sequenceNumber) })}</small>
                                {entry.reDispense &&
                                    <span className="protocol-dispense__redispensed-tag">{t('inventory.commons.reDispense')}</span>}
                            </div>
                        </Panel.Title>
                        {!disabled && (
                            <div>
                                {!entry.reDispense && onReDispense != null && entry.releaseTargetState !== 'Missed' && (
                                    <button className="btn btn-info" type="button" onClick={onReDispense} style={{ marginRight: '.5rem' }}>
                                        <Tooltip tooltip={t('inventory.commons.reDispense')} id={`tooltip-redispense-return-${index}`}>
                                            <span aria-hidden="true"><Add /></span>
                                        </Tooltip>
                                    </button>
                                )}
                                <button className="btn btn-danger" type="button" disabled={entry.reDispense} onClick={onRemove}>
                                    <Tooltip tooltip={t('commons.remove')} id={`tooltip-remove-return-${index}`}>
                                        <span aria-hidden="true"><Remove /></span>
                                    </Tooltip>
                                </button>
                            </div>
                        )}
                    </div>
                </Panel.Title>
            </Panel.Heading>
            <Panel.Body collapsible>
                <div className='input-group-container'>
                    <FormGroup style={{ width: "100%" }}>
                        <input disabled value={entry.release?.lotNumber ?? ''} className="rbt-input-main form-control rbt-input" />
                    </FormGroup>
                    <FormGroup style={{ width: "100%" }}>
                        <input disabled
                            value={entry.release?.expirationDate ? moment(entry.release.expirationDate).format('DD/MM/YYYY') : ''}
                            className="rbt-input-main form-control rbt-input" />
                    </FormGroup>
                </div>
                <div className='input-group-container'>
                    <FormGroup style={{ width: "50%" }}>
                        <ControlLabel>{t('inventory.commons.kitQuantity')}</ControlLabel>
                        <input disabled value={`${entry.returned} / ${entry.perUnitTotal}`} className="form-control" />
                    </FormGroup>
                </div>
            </Panel.Body>
        </Panel>
    );
}
